import { useTranslation } from 'react-i18next';
import { HeaderActionType } from '../../../Header/HeaderActionType';
import { WarningDialogResource } from '../../Warning/WarningDialog';
import redoHLAADialogResource from './RedoHLAADialogResource.json';

function useRedoHLAADialogResource(): WarningDialogResource {
    const { t } = useTranslation();
    const { headerContent, buttons } = redoHLAADialogResource;

    const header = {
        id: headerContent.id,
        text: t(headerContent.translationKey),
        type: HeaderActionType.NoAction,
    };

    const warningMessage = {
        id: redoHLAADialogResource['orionApp'].warningMessageContent.id,
        text: t(
            redoHLAADialogResource['orionApp'].warningMessageContent
                .translationKey
        ),
    };

    const buttonLabels = {
        primaryLabel: {
            id: buttons.primary.id,
            label: t(buttons.primary.translationKey),
        },
        secondaryLabel: {
            id: buttons.secondary.id,
            label: t(buttons.secondary.translationKey),
        },
    };

    return {
        header,
        warningMessage,
        buttonLabels,
    };
}

export default useRedoHLAADialogResource;
